import React, { useContext, useState, useEffect } from "react";
import {
  Typography,
  Stack,
  Box,
  TextField,
  InputAdornment,
  Button,
  Avatar,
  TableContainer,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  FormControl,
  Select,
  MenuItem,
  FormControlLabel,
  Switch,
  Divider,
} from "@mui/material";
import Grid from "@mui/material/Grid2";
import { Link } from "react-router-dom";
import { styled } from "@mui/material/styles";
//Icons
import { LuSearch } from "react-icons/lu";
import romdul from "../../Assets/romdul.png";
import AddToPhotosIcon from "@mui/icons-material/AddToPhotos";

//Srcs
import "../../Style/pageStyle.scss";
import { AuthContext } from "../../Context/AuthContext";
import { translateLauguage } from "../../Function/Translate";
import EmptyData from "../../Components/Include/EmptyData";
import LoadingPage from "../../Components/Include/LoadingPage";
import FooterPagination from "../../Components/Include/FooterPagination";
import { CreateUser } from "../../Components/User/CreateUser";
import {
  GET_USER_WITH_PAGINATION,
  UPDATE_USER_STATUS,
} from "../../Schema/Users";
import { useMutation, useQuery } from "@apollo/client";
import UserAction from "../../Components/User/UserAction";

export const User = () => {
  // ===================== Change Language ==========================
  const { language, setAlert } = useContext(AuthContext);
  const { t } = translateLauguage(language);

  const [loading, setLoading] = useState(true);

  const [openCreate, setOpenCreate] = useState(false);
  const handleOpen = () => setOpenCreate(true);
  const handleClose = () => setOpenCreate(false);

  const [tableData, setTableData] = useState();
  const [keyword, setKeyword] = useState("");
  const [paginationData, setPaginationData] = useState();
  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState(10);
  const [role, setRole] = useState("All");

  const { refetch } = useQuery(GET_USER_WITH_PAGINATION, {
    variables: {
      page: page,
      limit: limit,
      pagination: true,
      keyword: keyword,
      role: role ? role : "",
    },
    onCompleted: ({ getUserPagination }) => {
      setTableData(getUserPagination?.data);
      setPaginationData(getUserPagination?.paginator);
      setLoading(false);
    },
    onError: (err) => {
      console.log("Error::", err?.message);
    },
  });

  const handleLimit = (e) => {
    setLimit(e.target.value);
    setPage(1);
  };

  // =============== swtich ============================

  const userLogin = JSON.parse(window.localStorage.getItem("logIn"));

  const [updateUserStatus] = useMutation(UPDATE_USER_STATUS, {
    onCompleted: ({ updateUserStatus }) => {
      // console.log("updateUserStatus::", updateUserStatus);
      if (updateUserStatus?.is_success) {
        setAlert(true, "success", updateUserStatus?.message);
        refetch();
      } else {
        setAlert(true, "error", updateUserStatus?.message);
      }
    },
    onError: (error) => {
      setAlert(true, "error", error?.message);
    },
  });

  const handleUpdateStatus = (id, status) => {
    updateUserStatus({
      variables: {
        id: id,
        input: {
          is_enabled: !status,
        },
      },
    });
  };

  const Android12Switch = styled(Switch)(({ theme }) => ({
    padding: 8,
    "& .MuiSwitch-track": {
      borderRadius: 22 / 2,
      "&::before, &::after": {
        content: '""',
        position: "absolute",
        top: "50%",
        transform: "translateY(-50%)",
        width: 16,
        height: 16,
      },
      "&::before": {
        backgroundImage: `url('data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" height="16" width="16" viewBox="0 0 24 24"><path fill="${encodeURIComponent(
          theme.palette.getContrastText(theme.palette.primary.main)
        )}" d="M21,7L9,19L3.5,13.5L4.91,12.09L9,16.17L19.59,5.59L21,7Z"/></svg>')`,
        left: 12,
      },
      "&::after": {
        backgroundImage: `url('data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" height="16" width="16" viewBox="0 0 24 24"><path fill="${encodeURIComponent(
          theme.palette.getContrastText(theme.palette.primary.main)
        )}" d="M19,13H5V11H19V13Z" /></svg>')`,
        right: 12,
      },
    },
    "& .MuiSwitch-thumb": {
      boxShadow: "none",
      width: 16,
      height: 16,
      margin: 2,
    },
  }));

  // ======================= Resize width Screen ======================
  const [width, setWidth] = useState(window.innerWidth);
  const updateDimensions = () => {
    setWidth(window.innerWidth - 50);
  };
  useEffect(() => {
    window.addEventListener("resize", updateDimensions);
    return () => window.removeEventListener("resize", updateDimensions);
  }, []);

  // console.log("tableData::::", tableData);

  return (
    <div className="page-container">
      <Stack direction="column">
        <Stack direction="row" spacing={2} className="page-header">
          <Stack direction="column" justifyContent="center">
            <Box className="slash" />
          </Stack>
          <Stack direction="column" justifyContent="center">
            <Link className="page-link-title" to="/setting">
              <Typography
                className={language === "kh" ? "page-title-kh" : "page-title"}
              >
                {t(`page-setting`)}
              </Typography>
            </Link>
          </Stack>
          <Stack direction="column" justifyContent="center">
            <Typography className="slash-title">/</Typography>
          </Stack>
          <Stack
            direction="column"
            justifyContent="center"
            alignItems={`center`}
          >
            <Typography
              className={language === "kh" ? "page-title-kh" : "page-title"}
            >
              {t(`user`)}
            </Typography>
          </Stack>
        </Stack>
        <Stack mt={2}>
          <Divider />
        </Stack>
      </Stack>

      <Box sx={{ marginTop: "30px" }}>
        <Grid container spacing={2}>
          <Grid size={{ xs: 6, sm: 6, md: 4, lg: 3, xl: 2 }}>
            <Typography
              className={language === "kh" ? "header-text-kh" : "header-text"}
            >
              {t(`label-search`)}
            </Typography>
            <TextField
              placeholder={t(`label-search`)}
              size="small"
              className="search-field"
              onChange={(e) => setKeyword(e.target.value)}
              InputProps={{
                startAdornment: (
                  <InputAdornment
                    position="start"
                    sx={{ mr: 1, color: "#158843", fontSize: "22px" }}
                  >
                    <LuSearch />
                  </InputAdornment>
                ),
              }}
            />
          </Grid>
          <Grid size={{ xs: 6, sm: 6, md: 4, lg: 3, xl: 2 }}>
            <Typography
              className={language === "kh" ? "header-text-kh" : "header-text"}
            >
              {t(`label_role`)}
            </Typography>
            <FormControl className="search-field" fullWidth size="small">
              <Select value={role} onChange={(e) => setRole(e.target.value)}>
                <MenuItem value="All">All</MenuItem>
                <MenuItem value="Admin">Admin</MenuItem>
                <MenuItem value="Teacher">Teacher</MenuItem>
              </Select>
            </FormControl>
          </Grid>
          <Grid size={{ xs: 12, sm: 12, md: 4, lg: 3, xl: 8 }}>
            <Stack direction="row" justifyContent="right">
              <Button
                onClick={handleOpen}
                className="btn-create-style"
                startIcon={
                  // <img src={romdul} alt="romdul" className="icon-add" />
                  <AddToPhotosIcon className="icon-add" />
                }
              >
                <Typography
                  className={language === "kh" ? "btn-txt-kh" : "btn-txt"}
                >
                  {t("btn-create")}
                </Typography>
              </Button>
            </Stack>
            <CreateUser
              open={openCreate}
              handleClose={handleClose}
              setRefetch={refetch}
            />
          </Grid>
        </Grid>
      </Box>

      <Box className="body-container">
        <TableContainer sx={{ maxWidth: `${width}px` }}>
          <Table className="table" aria-label="simple table">
            <TableHead className="header-row ">
              <TableRow>
                <TableCell
                  className={
                    language === "en"
                      ? "header-title-start"
                      : "header-title-start-kh"
                  }
                >
                  {t("thead_no")}
                </TableCell>
                <TableCell
                  className={
                    language === "en" ? "header-title" : "header-title-kh"
                  }
                >
                  {t("user_name")}
                </TableCell>
                <TableCell
                  className={
                    language === "en" ? "header-title" : "header-title-kh"
                  }
                >
                  {t("thead_latin_name")}
                </TableCell>
                <TableCell
                  className={
                    language === "en" ? "header-title" : "header-title-kh"
                  }
                >
                  {t("thead_gender")}
                </TableCell>
                <TableCell
                  className={
                    language === "en" ? "header-title" : "header-title-kh"
                  }
                >
                  {t("phone")}
                </TableCell>
                <TableCell
                  className={
                    language === "en" ? "header-title" : "header-title-kh"
                  }
                >
                  {t("email")}
                </TableCell>
                <TableCell
                  className={
                    language === "en" ? "header-title" : "header-title-kh"
                  }
                >
                  {t("role")}
                </TableCell>
                <TableCell
                  className={
                    language === "en" ? "header-title" : "header-title-kh"
                  }
                >
                  {t("thead_status")}
                </TableCell>
                <TableCell
                  className={
                    language === "en"
                      ? "header-title-end"
                      : "header-title-end-kh"
                  }
                ></TableCell>
              </TableRow>
            </TableHead>

            {loading ? (
              <TableBody className="table-body">
                <TableRow className="body-row">
                  <TableCell colSpan={10} className="body-cell">
                    <LoadingPage />
                  </TableCell>
                </TableRow>
              </TableBody>
            ) : (
              <>
                {tableData?.length === 0 ? (
                  <TableBody className="table-body">
                    <TableRow className="body-row">
                      <TableCell colSpan={10} className="body-cell">
                        <EmptyData />
                      </TableCell>
                    </TableRow>
                  </TableBody>
                ) : (
                  <>
                    <TableBody className="table-body">
                      {tableData?.map((row, index) => {
                        // console.log("row::", row)
                        return (
                          <TableRow className="body-row" key={index}>
                            <TableCell
                              className={
                                language === "en"
                                  ? "body-cell-start"
                                  : "body-cell-start-kh"
                              }
                            >
                              {index + paginationData?.slNo}
                            </TableCell>
                            <TableCell className="body-cell-kh">
                              {/* {row?.last_name} {row?.first_name} */}
                              {`${row?.last_name} ${row?.first_name}`}
                            </TableCell>
                            <TableCell
                              className={
                                language === "en" ? "body-cell" : "body-cell-kh"
                              }
                            >
                              {row?.latin_name}
                            </TableCell>
                            <TableCell
                              className={
                                language === "en" ? "body-cell" : "body-cell-kh"
                              }
                            >
                              {row?.gender}
                            </TableCell>
                            <TableCell
                              className={
                                language === "en" ? "body-cell" : "body-cell-kh"
                              }
                            >
                              {row?.phone_number}
                            </TableCell>
                            <TableCell
                              className={
                                language === "en" ? "body-cell" : "body-cell-kh"
                              }
                            >
                              {row?.email}
                            </TableCell>
                            <TableCell
                              className={
                                language === "en" ? "body-cell" : "body-cell-kh"
                              }
                            >
                              {row?.role}
                            </TableCell>
                            <TableCell
                              className={
                                language === "en" ? "body-cell" : "body-cell-kh"
                              }
                            >
                              <FormControlLabel
                                control={
                                  <Android12Switch
                                    disabled={
                                      userLogin?._id === row?._id ? true : false
                                    }
                                    checked={row?.is_enabled}
                                    onChange={() =>
                                      handleUpdateStatus(
                                        row?._id,
                                        row?.is_enabled
                                      )
                                    }
                                  />
                                }
                              />
                            </TableCell>
                            <TableCell
                              className={
                                language === "en"
                                  ? "body-cell-end"
                                  : "body-cell-end-kh"
                              }
                              align="right"
                            >
                              <UserAction editData={row} setRefetch={refetch} />
                            </TableCell>
                          </TableRow>
                        );
                      })}
                    </TableBody>
                  </>
                )}
              </>
            )}
          </Table>
        </TableContainer>
        {/* ==================== Pagination  ============================= */}
        <FooterPagination
          totalPages={paginationData?.totalPages}
          totalDocs={paginationData?.totalDocs}
          limit={limit}
          page={page}
          setPage={setPage}
          handleLimit={handleLimit}
          // setLoading={setLoading}
        />
      </Box>
    </div>
  );
};
